const basePersonsApiPath = 'organizations/:organizationId/persons';

export const personsApiPaths = {
    person: `${basePersonsApiPath}/:personId`,
    persons: basePersonsApiPath,
    invitationEmails: `${basePersonsApiPath}/:personId/invitation-emails`,
} as const;
